import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import {faAnglesUp, faAnglesDown} from "@fortawesome/free-solid-svg-icons";

declare let jQuery: any;

@Component({
    selector: 'app-scroll-buttons',
    templateUrl: './scroll-buttons.component.html',
    styleUrls: ['./scroll-buttons.component.scss']
})
export class ScrollButtonsComponent implements OnInit, AfterViewInit {
    @Input() contentId;
    @Input() scrollSize = 300;

    readonly faAnglesUp = faAnglesUp;
    readonly faAnglesDown = faAnglesDown;

    $itemList;

    constructor() { }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.contentId) {
                this.$itemList = jQuery(`#${this.contentId}`);
            }
        }, 333);
    }

    // scroll down and up button event on mobile mode
    scrollUpDown(isDown = false) {
        const step = isDown ? Number(this.scrollSize) : -1 * Number(this.scrollSize);
        if (this.$itemList) {
            this.$itemList.stop().animate({
                scrollTop: this.$itemList.scrollTop() + step
            }, 300, 'swing');
        }
    }
}
